import React from "react";
import TermsOfServiceScreen from "./terms-of-service-screen";
import { Box, Divider, Container } from "@mui/material";

const TermsOfServicePublic: React.FC = () => {
    return (
        <Box sx={{ bgcolor: "#fff", minHeight: "100vh" }}>
            <Divider sx={{ mb: 0 }} />
            <Container maxWidth="xl">
                <TermsOfServiceScreen viewOnly={true} variant="public" />
            </Container>
        </Box>
    );
};

export default TermsOfServicePublic;
